var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8759,
    cy: 20.0262,
    r: 19.9462,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_502_107867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6367 18.2924C33.97 19.0622 33.9701 20.9867 32.6367 21.7565L16.497 31.0748C15.1637 31.8446 13.497 30.8823 13.497 29.3427L13.497 10.7062C13.497 9.16659 15.1637 8.20434 16.497 8.97414L32.6367 18.2924Z",
    fill: "url(#paint0_linear_502_107867)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_502_107867",
    x: -18.7751,
    y: -23.5681,
    width: 84.6831,
    height: 87.185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.1356
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_107867"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_107867",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_107867",
    x1: 6.11713,
    y1: 39.0103,
    x2: 6.264,
    y2: -8.83298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlay);
export default __webpack_public_path__ + "static/media/AudioPlay.1e4aa6c04d58d0e801d803671d1c3d62.svg";
export { ForwardRef as ReactComponent };